wbApp.controller('LeadsTabsCrmNotesDetailCtrl', ['$scope', '$modal', '$translate', 'leadSvc', 'securitySvc',
function ($scope, $modal, $translate, leadSvc, securitySvc) {

    $scope.model = {}; // Single note
    $scope.lead = null;   // Full lead object
    $scope.isDisabled = true;

    function loadData(leadId, noteId) {
        $scope.isLoading = true;

        leadSvc.getById(leadId).$promise.then(function (data) {

            $scope.lead = data;

            if ($scope.lead.status == 1) {
                $scope.detailError = { errors: [{ message: $translate.instant('TXT_ERROR_LEAD_ALREADY_CONVERTED') }] };
                $scope.isSaving = false;
                $scope.isDisabled = true;
            } else {
                $scope.isDisabled = false;
            }

            if (!data.notes || typeof noteId === 'undefined' || noteId === null) {
                data.notes = data.notes || [];
                $scope.model = {};
                data.notes.push($scope.model);
            } else {
                var idx = _.findIndex(data.notes, { 'id': noteId });
                if (idx != -1) {
                    $scope.model = data.notes[idx];
                    if ($scope.model) {
                        $scope.model.updatedAtUtc = moment().toDate();
                        var user = securitySvc.loggedInUser();

                        $scope.model.updatedByUserId = user.userID + "";
                        $scope.model.updatedByName = user.fullName;
                    }
                } else {
                    $scope.model = {};
                    data.notes.push($scope.model);
                }
            }
           
            $scope.leadOrig = angular.copy($scope.lead);

            $scope.isLoading = false;
        }, function (error) {
            $scope.model = {};
            $scope.isLoading = false;
        });
    }

    loadData($scope.leadId, $scope.noteId);

    $scope.detailIsUnchanged = function (data) {
        return angular.equals(data, $scope.leadOrig);
    };

    $scope.isSaving = false;

    $scope.onDetailSave = function () {

        $scope.isSaving = true;

        leadSvc.update($scope.lead).$promise.then(success, error);

        function success() {
            $scope.isSaving = false;
            $scope.$hide();
            if (!!$scope.onLeadSave) {
                $scope.onLeadSave($scope.lead);
            }
        }

        function error(data) {
            $scope.isSaving = false;
            $scope.detailError = data;
        }
    }

}]);
